export const SECTION_TITLE_FACELIFT_REVIEWS = 'Facelift Review';
export const SECTION_TITLE_RELATED_ARTICLES = 'Related Articles';
export const SECTION_TITLE_DISCUSSIONS = 'Related Discussions';
